export const IDENTITY_VERIFICATION_COMPLETE = 'IDENTITY_VERIFICATION_COMPLETE' as const;
